const idPrefix = 'katal-id-';
let num = 0;

export function nextUniqueId() {
  return `${idPrefix}${num++}`;
}
